module.exports = __webpack_public_path__ + "img/stock6.e5838a83.png";